import { render, staticRenderFns } from "./ChildContentsPage.vue?vue&type=template&id=a1b1af8e&scoped=true&"
import script from "./ChildContentsPage.vue?vue&type=script&lang=js&"
export * from "./ChildContentsPage.vue?vue&type=script&lang=js&"
import style0 from "./ChildContentsPage.vue?vue&type=style&index=0&id=a1b1af8e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1b1af8e",
  null
  
)

export default component.exports